import React from "react";
import { connect } from "react-redux";
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";
import { required, noSpaces } from "utils/validation";
import { reduxFormInput, reduxFormSelect } from "components/form/ReduxForm";
import { getCategories, mergeCategories } from "redux/actions";
import Spacer from "components/layout/Spacer";

class MergeCategories extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      categoryOptions: [],
    };

    this.submitFn = this.submitFn.bind(this);
  }

  componentDidMount() {
    this.handleGetCategories();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.categories !== this.props.categories) {
      const categoryOptions = this.props.categories.map((item) => ({
        value: item._id,
        label: item.categoryName,
      }));
      this.setState({ categoryOptions });
    }
  }

  submitFn(data) {
    const ids = data.categories.map((item) => item.value);
    mergeCategories({ ids, categoryName: data.categoryName });
  }

  handleGetCategories = () => {
    getCategories();
  };

  render() {
    const { action, handleSubmit } = this.props;
    const isProcessing =
      action.CREATE_CATEGORY.isFetching || action.UPDATE_CATEGORY.isFetching;

    return (
      <>
        <Container>
          <Form
            className="no-border no-padding"
            onSubmit={handleSubmit(this.submitFn)}
          >
            <Row>
              <Col xs="12">
                <Field
                  isMulti
                  showLoading
                  closeMenuOnSelect={false}
                  className="form-control"
                  component={reduxFormSelect}
                  validate={[required]}
                  name="categories"
                  type="select"
                  isLoading={action.GET_CATEGORIES.isFetching}
                  options={this.state.categoryOptions}
                  placeholder="Select at least 2 categories..."
                  label="*Categories"
                  onFocus={this.handleGetCategories}
                />
                <Spacer size={10} />
              </Col>
            </Row>

            <Row>
              <Col xs="12">
                <Field
                  className="form-control"
                  component={reduxFormInput}
                  validate={[required, noSpaces]}
                  name="categoryName"
                  type="text"
                  placeholder="Enter new category"
                  label="*New Category"
                />
              </Col>
            </Row>
            <Spacer size={50} />
            <Row className="justify-content-center">
              <Col className="text-center" xs="12" sm="6">
                <Button disabled={isProcessing} type="submit" variant="primary">
                  {isProcessing ? "Saving..." : "Save"}
                </Button>
              </Col>
            </Row>
          </Form>
          <Spacer size={50} />
        </Container>
      </>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    action: state.action,
    categories: state.category.categories,
    initialValues: {
      categoryName:
        props.selectedCategories?.map((e) => e.categoryName).join(" ") || "",
      categories: (props.selectedCategories || []).map((item) => ({
        value: item._id,
        label: item.categoryName,
      })),
    },
  };
}

export default connect(mapStateToProps)(
  reduxForm({
    form: "MergeCategories",
    enableReinitialize: true,
  })(MergeCategories)
);
